import { Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ToolCapaciteService } from '../../../tool-capacite.service';
import { ConseilsPreautorisationComponent } from '../../components/conseils-preautorisation/conseils-preautorisation.component';
import { DashboardCardStatusComponent } from '../../components/dashboard-card-status/dashboard-card-status.component';
import { DebugComponent } from '../../components/debug/debug.component';
import { StatusCapaciteEnum } from '../../constants/status-capacite.enum';
import { CapaciteModel } from '../../modeles/capacite.model';
import { EtapeMiseFondsDataModel } from '../../modeles/etape-mise-fonds-data.model';
import { CapaciteSelectors } from '../../capacite.selectors';
import { ChargerCapacite, NavigatePageResultat, PatchCapaciteDebugOnly } from '../../capacite.actions';

@Injectable({
  providedIn: 'root'
})
export class CapaciteService extends ToolCapaciteService {
  version = 'latest';

  readonly dashboardComponent: unknown = DashboardCardStatusComponent;
  readonly debugComponent: unknown = DebugComponent;
  readonly conseilsComponent: unknown = ConseilsPreautorisationComponent;

  @Select(CapaciteSelectors.isCapacityStarted)
  isCapacityFormInProgress$: Observable<boolean>;
  @Select(CapaciteSelectors.statutCapacite)
  statutCapacite$: Observable<StatusCapaciteEnum>;
  @Select(CapaciteSelectors.donneesResultat)
  donneesResultat$: Observable<any>;
  @Select(CapaciteSelectors.donneesCapacite)
  donneesCapacite$: Observable<CapaciteModel>;
  @Select(CapaciteSelectors.totalDepenses)
  totalDepenses$: Observable<number>;
  @Select(CapaciteSelectors.totalEngagements)
  totalEngagements$: Observable<number>;
  @Select(CapaciteSelectors.donneesEtapeMiseFonds)
  donneesEtapeMiseFonds$: Observable<EtapeMiseFondsDataModel>;
  @Select(CapaciteSelectors.isCapacityCompleted)
  isCapacityCompleted$: Observable<boolean>;
  @Select(CapaciteSelectors.isCapacityCompletedAndLoaded)
  isCapacityCompletedAndLoaded$: Observable<any>;

  constructor(private readonly _store: Store) {
    super();
  }

  async initialize() {
    await this._store.dispatch(new ChargerCapacite()).toPromise();
  }

  patchDebugOnly(data: Partial<CapaciteModel>, isCompleted: boolean) {
    this._store.dispatch(new PatchCapaciteDebugOnly(data, isCompleted));
  }

  modifierEtape(_: string, __: string) {
    // TODO aller directement à une étape à partir des propriétés
    this._store.dispatch(new NavigatePageResultat());
  }
}
